
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/linga-bhairavi/[region]/[lang]/article/[article]",
      function () {
        return require("private-next-pages/linga-bhairavi/[region]/[lang]/article/[article]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/linga-bhairavi/[region]/[lang]/article/[article]"])
      });
    }
  